import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import('./bootstrap');
